import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {Stack} from 'shells/layout/stack/stack';
import {Modal} from 'shells/modal/modal';
import {Body} from 'shells/typography/body';

import type {GetCalendars_calendars as Calendar} from 'nutshell-graphql-types';

import {CalendarList} from './calendar-list';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    calendars: Calendar[];
    currentSelectionId: string | null | undefined;
    onSave: (selectedCalendarId: string) => void;
    modalType: 'sync' | 'conflict';
    isAddingCalendar: boolean;
    isEmbedded?: boolean;
};

export function SelectCalendarModal(props: Props) {
    const [selectedCalendarId, setSelectedCalendarId] = React.useState<string | null | undefined>(
        props.currentSelectionId
    );

    const productDisplayName = props.isEmbedded ? 'SchedulerFX' : 'Nutshell';

    return (
        <Modal
            headerText={
                props.modalType === 'sync'
                    ? 'Which calendar would you like to sync?'
                    : 'Which calendar would you like to add?'
            }
            isOpen={props.isOpen}
            onClose={props.onClose}
            closeButton={false}
            maxWidth={480}
            maxHeight={400}
            canClickOutsideToClose={false}
        >
            <Stack spacing={24} justifyContent='space-between' isFullHeight={true}>
                <Stack spacing={24}>
                    <Body>
                        {props.modalType === 'sync'
                            ? `${productDisplayName} can add events to this calendar and import events from it.`
                            : `${productDisplayName} can take these calendar events into consideration for scheduling conflicts.`}
                    </Body>
                    <CalendarList
                        calendars={props.calendars}
                        selectedCalendarId={selectedCalendarId}
                        onSelectCalendar={setSelectedCalendarId}
                        modalType={props.modalType}
                    />
                </Stack>
                <div className='flex align-center justify-sb pb-32'>
                    <Button variant='text-secondary' onClick={props.onClose} noPadding={true}>
                        Cancel
                    </Button>
                    <SaveButton
                        isSaving={props.isAddingCalendar}
                        disabled={!selectedCalendarId}
                        // @ts-expect-error
                        onClick={() => {
                            if (selectedCalendarId) {
                                props.onSave(selectedCalendarId);
                            }
                        }}
                        onClearSaveComplete={() => {
                            props.onClose();
                        }}
                        saveCompleteTimeout={1000}
                        buttonText={props.modalType === 'sync' ? 'Select calendar' : 'Add calendar'}
                    />
                </div>
            </Stack>
        </Modal>
    );
}
